import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AdminContext = createContext(null);

export const useAdmin = () => {
  const ctx = useContext(AdminContext);
  if (!ctx) throw new Error('useAdmin must be used within AdminProvider');
  return ctx;
};

export const AdminProvider = ({ children }) => {
  const navigate = useNavigate();
  const [token, setToken] = useState(() => localStorage.getItem('admin_token'));
  const [adminName, setAdminName] = useState(() => localStorage.getItem('admin_name') || 'Admin');
  const [loading, setLoading] = useState(true);

  const authHeaders = useCallback(() => ({
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  }), [token]);

  const logout = useCallback(() => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_name');
    setToken(null);
    navigate('/admin/login');
  }, [navigate]);

  useEffect(() => {
    if (!token) {
      setLoading(false);
      return;
    }
    // Verify token is still valid
    fetch(`${API_URL}/api/admin/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        if (res.status === 401) { logout(); return; }
        return res.json();
      })
      .then(data => {
        if (data?.name) setAdminName(data.name);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [token, logout]);

  return (
    <AdminContext.Provider value={{ token, adminName, authHeaders, logout, loading, apiUrl: API_URL }}>
      {children}
    </AdminContext.Provider>
  );
};
